import { normalizeDueTerms } from '../dueTerms.js';
import { uiSlotsFromSettings, legacyFromSlot1 } from '../trackingSlots.js';

export function buildIntegrationsPayload(formData, billSettings, invoiceTrackingSettings, invoiceCostFeeSettings) {
  const payload = {
    jobtreadApiKey: formData.jobtreadApiKey.trim() || 'BLANK',
    jobtreadOrgId: formData.jobtreadOrgId.trim() || 'BLANK',
    xeroInvoiceCode: formData.xeroInvoiceCode,
    xeroExpenseCode: formData.xeroExpenseCode,
    xeroUSTaxType: formData.xeroUSTaxType || null,
    xeroGBTaxType: formData.xeroGBTaxType || null,
    xeroCATaxType: formData.xeroCATaxType || null,
    country: formData.country,
    province: formData.country === 'CA' ? (formData.province || null) : null,
    excludedCostCodes: formData.excludedCostCodes || '',
    accountingPlatform: formData.accountingPlatform === 'quickbooks' ? 'quickbooks' : 'xero',
    billSettings: {
      ...legacyFromSlot1(uiSlotsFromSettings(billSettings, 'jtBillNameField'), 'jtBillNameField'),
      tracking: uiSlotsFromSettings(billSettings, 'jtBillNameField'),
      billmodedefaultjob: billSettings.billmodedefaultjob,
      billsAndExpenses: billSettings.billsAndExpenses ?? false,
      xeroExpenseBankAccountID: billSettings.xeroExpenseBankAccountID || '',
      xeroExpenseBankAccountName: billSettings.xeroExpenseBankAccountName || '',
      xeroExpenseAutoPayment: billSettings.xeroExpenseAutoPayment ?? true,
      xeroExpenseSyncMode: billSettings.xeroExpenseSyncMode || 'bill',
      skipAutoApprove: billSettings.skipAutoApprove ?? false,
      markDirectImportBillsAsPaid: billSettings.markDirectImportBillsAsPaid ?? false,
      requireDirectBillApproval: billSettings.requireDirectBillApproval ?? false,
      directBillDueTerms: normalizeDueTerms(billSettings.directBillDueTerms),
      multiCurrencyEnabled: billSettings.multiCurrencyEnabled ?? false
    },
    invoiceTrackingSettings: {
      ...legacyFromSlot1(uiSlotsFromSettings(invoiceTrackingSettings, 'jtJobField'), 'jtJobField'),
      tracking: uiSlotsFromSettings(invoiceTrackingSettings, 'jtJobField'),
      lineItemRoundingMode: invoiceTrackingSettings.lineItemRoundingMode === 'summarise' ? 'summarise' : 'preserve',
      syncAsDraft: !!invoiceTrackingSettings.syncAsDraft
    }
  };
  // Only include cost-and-fee settings when supplied, so callers that don't
  // manage them leave the stored values untouched (server merges when present).
  if (invoiceCostFeeSettings) {
    payload.invoiceCostFeeSettings = {
      enabled: !!invoiceCostFeeSettings.enabled,
      feeAccountCode: invoiceCostFeeSettings.feeAccountCode || '',
      feeLabel: invoiceCostFeeSettings.feeLabel || "Builder's Fee"
    };
  }
  return payload;
}

export async function postIntegrations(payload) {
  const response = await fetch('/api/users/integrations', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.error || 'Failed to save settings');
  }

  return data;
}

export async function fetchIntegrations() {
  const response = await fetch('/api/users/integrations');
  if (!response.ok) {
    throw new Error('Failed to load settings');
  }

  const data = await response.json();
  if (!data.success) {
    throw new Error('Failed to load settings');
  }

  return data;
}
